module.exports = __webpack_public_path__ + "static/media/sicbo.fbb214be.webp";